import { makeStyles } from '@material-ui/core';

export default makeStyles({
  paper: {
    minWidth: 226,
  },
});
